import { Component } from "react";
import GetIcon from "./GetIcon.tsx";
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Stack, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import { MdClose } from "react-icons/md";
import RoundButton from "./RoundButton.jsx";

export default class ReservDialog extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Dialog open={true} sx={{ zIndex: 99999 }}>
                <DialogTitle color="primary" fontSize={12}><b>PRODUTOS COM RESERVAS</b></DialogTitle>
                <IconButton onClick={e => this.props.onClose()} sx={{ position: 'absolute', right: 8, top: 8 }}>
                    <MdClose size={18} />
                </IconButton>
                <DialogContent>
                    <Stack  mt={-2}>
                        <Typography variant="caption" mb={2}>Não foi possível continuar com o inventário pois existem produtos com reservas.</Typography>
                        <Typography variant="caption" fontWeight={500} mb={1}><b>Produtos reservados</b></Typography>
                        <Stack>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell width={40}>Cód.</TableCell>
                                        <TableCell >Nome</TableCell>
                                        <TableCell width={50}>Deriv.</TableCell>
                                        <TableCell>Quant.</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.props.produtos.map((produto) => (
                                        <TableRow key={produto.codigo + produto.derivacao}>
                                            <TableCell>{produto.codPro}</TableCell>
                                            <TableCell>{produto.desPro}</TableCell>
                                            <TableCell>{produto.codDer}</TableCell>
                                            <TableCell>{produto.qtdRae}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Stack>
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <RoundButton onClick={e => this.props.onClose()}>Ok</RoundButton>
                </DialogActions>
            </Dialog>
        );
    }
}
